<!--  -->
<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
    <el-breadcrumb-item>组织架构</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(nav, index) in navMenu" :key="index">{{
        nav
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>

export default {
  name: 'breadCrumb',
  props: {
    navMenu: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../css/common.scss";
.breadcrumb {
  width: 100%;
  height: 100%;
  ::v-deep .el-breadcrumb {
    .el-breadcrumb__item {
      &:last-of-type {
        .el-breadcrumb__inner {
          color: $color-default;
        }
      }
      .el-breadcrumb__inner {
        color: $color-gery;
      }
    }
  }
}
</style>